<i18n src="@/locales/components/LoginTranslate.json"></i18n>

<template>
	<div class="form-login-jwt">
		<form @submit.prevent="loginJWT" autocomplete="off">
			<div class="vx-row mb-2">
				<div class="vx-col w-full">
					<cbs-input v-validate="'required'" name="email" icon-no-border icon="icon-user" icon-pack="feather" label-placeholder="Email/Phone" v-model="email" class="w-full mt-0" />
					<span class="text-danger text-sm">
						<p class="capitalize-first-letter">{{ errors.first("email") }}</p>
					</span>
				</div>
			</div>

			<div class="vx-row mb-2">
				<div class="vx-col w-full">
					<cbs-input
						v-validate="'required'"
						type="password"
						name="password"
						:data-vv-as="$t('Password')"
						icon-no-border
						icon="icon-lock"
						icon-pack="feather"
						:label-placeholder="$t('Password')"
						v-model="password"
						class="w-full mt-6"
					/>
					<span class="text-danger text-sm">
						<p class="capitalize-first-letter">{{ errors.first("password") }}</p>
					</span>
				</div>
			</div>

			<!-- <div class="flex flex-wrap justify-between my-5">
				<vs-checkbox v-model="checkbox_remember_me" class="m-0">{{ $t("RememberMe") }}</vs-checkbox>
			</div> -->
			<div class="mt-4 flex flex-wrap md:flex-no-wrap justify-between">
				<vs-button class="font-bold w-full" :disabled="!validateForm" @click="loginJWT">{{ $t("Login") }}</vs-button>
				<!-- <vs-button class="font-bold w-full md:w-2/3 md:mr-3" :disabled="!validateForm" @click="loginJWT">{{ $t("Login") }}</vs-button> -->
				<!-- <vs-button class="font-bold w-full md:w-1/3 mt-3 order-1  md:mt-0 md:order-normal" type="border" @click="registerUser">{{ $t("Register") }}</vs-button> -->
				<button type="submit" class="hidden"></button>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			email: "",
			password: "",
			checkbox_remember_me: false
		};
	},
	computed: {
		validateForm() {
			return !this.errors.any() && this.email !== "" && this.password !== "";
		}
	},
	methods: {
		checkLogin() {
			// If user is already logged in notify
			if (this.$store.state.auth.isUserLoggedIn()) {
				// Close animation if passed as payload
				// this.$vs.loading.close()
				location.reload();
			}
			return true;
		},
		loginJWT() {
			if (!this.checkLogin()) return;
			this.$validator.validateAll().then(result => {
				if (result) {
					// Loading
					this.$vs.loading();

					const payload = {
						checkbox_remember_me: this.checkbox_remember_me,
						userDetails: {
							email: this.email,
							password: this.password
						}
					};

					this.$store
						.dispatch("auth/loginJWT", payload)
						.then(() => {
							this.$vs.loading.close();
						})
						.catch(error => {
							this.$vs.loading.close();
							this.$helper.notifyError({
								context: this,
								error,
								options: { text: this.$t(error.message) }
							});
						});
				}
			});
		},
		registerUser() {
			if (!this.checkLogin()) return;
			this.$router.push(this.$helper.currentAppPath() + "/register").catch(() => {});
		}
	}
};
</script>

<style lang="scss">
.form-login-jwt {
	::v-deep .vs-input {
		input {
			& ~ .vs-icon {
				top: 14px;
			}
		}

		&.isFocus input,
		input.hasValue {
			& ~ .input-span-placeholder {
				transform: translate(-3px, -65%) !important;
			}
		}
	}

	input:-webkit-autofill ~ span {
		-webkit-transform: translate(-3px, -90%) !important;
		transform: translate(-3px, -90%) !important;
		padding-left: 0.8rem !important;
		padding-top: 0.5rem !important;
	}
	.vs-con-input .input-span-placeholder {
		text-transform: capitalize;
	}
}
</style>
